(function () {
    'use strict';

    // var Vue = require('vue');
    // NOTE: This component is using Vue 1
    Vue.use(require('vue-resource'));
    Vue.directive('select', require('./directives/Select2'));
    if ($('#feedback-averages').length > 0) {
        new Vue({
            el: '#feedback-averages',
            data: {
                locationsFilter: [],
                countriesFilter: [],
                countryLocations: $.extend(true, {}, window.greenmotion.locations),
                question: null,
                score: null,
                questions: $.extend(true, {}, window.greenmotion.reports.overallAverage),
                scores: $.extend(true, {}, window.greenmotion.reports.scores),
            },
            computed: {
                locations: {
                    get: function () {
                        return this.locationsFilter;
                    },
                    set: function (value) {
                        this.locationsFilter = value;
                        this.calculate();
                    },
                },
                isCountrySelected: function () {
                    if (typeof this.countriesFilter == 'undefined') return false;
                    return this.countriesFilter.length > 0;
                },
                locationsForCountry: {
                    get: function () {
                        return this.countriesFilter;
                    },
                    set: function (value) {
                        var locations = this.countryLocations[window.greenmotion.countries[value]];
                        var selected = [];
                        $(locations).each(function (i, e) {
                            selected.push(e.value);
                        });
                        this.countriesFilter = locations;
                        this.$nextTick(function () {
                            $('#locations').val(selected).trigger('change');
                        });
                        this.locationsFilter = selected;
                    },
                },
            },
            methods: {
                setQuestion: function (key) {
                    if (key === 'average') {
                        return;
                    }

                    this.question = key;

                    this.calculate();
                },
                calculate: function () {
                    var scores = this.getScores();

                    this.updateAverages(scores);
                },
                getScores: function () {
                    var scores = [];

                    for (var key in this.scores) {
                        var score;

                        if (!this.question || !this.score) {
                            score = this.scores[key];
                        } else {
                            score = this.filterScores(this.scores[key]);
                        }

                        if (score) {
                            if (this.locations.length > 0 && this.locations.indexOf(score.location_id) === -1) {
                                continue;
                            }

                            scores.push(score);
                        }
                    }

                    return scores;
                },
                filterScores: function (score) {
                    for (var key in score) {
                        var value = score[key];

                        if (this.question == key && this.score == value) {
                            return score;
                        }
                    }
                },
                updateAverages: function (scores) {
                    if (scores.length === 0) {
                        for (var key in this.questions) {
                            if (key === 'location_id') {
                                continue;
                            }

                            this.questions[key].average = 'N/A';
                        }

                        return;
                    }

                    var averages = [];

                    for (var key in scores) {
                        var questions = scores[key];

                        for (var key in questions) {
                            if (key === 'average') {
                                continue;
                            }

                            var score = questions[key];

                            if (!averages[key]) {
                                averages[key] = 0;
                            }

                            averages[key] += parseInt(score);
                        }
                    }

                    var overallAverage = 0;

                    for (var key in averages) {
                        if (key === 'location_id') {
                            continue;
                        }

                        var average = Math.round((parseFloat(averages[key]) / scores.length) * 100) / 100;

                        this.questions[key].average = average;

                        overallAverage += average;
                    }
                    this.questions['average'].average = Math.round((parseFloat(overallAverage) / 5) * 100) / 100;
                },
                scoreColour: function (score) {
                    if (score > 4) {
                        return 'text-success';
                    } else if (score >= 2.5) {
                        return 'text-warning';
                    } else {
                        return 'text-danger';
                    }
                },
            },
            components: {
                'location-averages': require('./components/LocationAverages'),
            },
        });
    }
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/components/feedback/FeedbackAverages.js